/**
 * Tipos para transcripción en tiempo real (Deepgram Streaming + Telnyx WebRTC).
 *
 * Tipos genéricos del pipeline de transcripción,
 * independientes del proveedor de telefonía (Telnyx).
 */

// ─── Transcripción en Tiempo Real ─────────────────────────────────────────────

export type TranscriptionChannel = 'agent' | 'customer' | 'unknown';

export interface TranscriptionSegment {
  id: string;
  channel: TranscriptionChannel;
  text: string;
  isFinal: boolean;
  timestamp: number;
  confidence?: number;
  start?: number;
  duration?: number;
}

/** Mensaje JSON recibido del WebSocket de transcripción */
export interface TranscriptionWSMessage {
  type: 'transcription' | 'status' | 'error' | 'keepalive';
  channel?: TranscriptionChannel;
  transcript?: string;
  is_final?: boolean;
  speech_final?: boolean;
  confidence?: number;
  start?: number;
  duration?: number;
  status?: string;
  error?: string;
}

/** Mensaje de control enviado al WebSocket */
export interface TranscriptionControlMessage {
  type: 'start' | 'stop' | 'keepalive';
  call_id?: string;
  language?: string;
}

export type TranscriptionWSStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'error';

// ─── Audio Capture ────────────────────────────────────────────────────────────

export interface AudioCaptureConfig {
  sampleRate: number;       // Target: 16000 Hz (Deepgram optimal)
  chunkIntervalMs: number;  // 250ms chunks
  channels: 1;              // Mono
}

/** Canal de audio: 0x00 = agente (mic), 0x01 = cliente (remoto) */
export const AUDIO_CHANNEL_AGENT = 0x00;
export const AUDIO_CHANNEL_CUSTOMER = 0x01;
